import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";

export default class SkyContainer extends BaseContainer {

  constructor(width= 2300) {
    super()
    this.init(width)
  }

  init(width) {
    this.sprite = new PIXI.Sprite(PIXI.Texture.from('parallax/Sky'))
    this.sprite.scale.set(width + 0.2, 1)
    this.sprite.position.x = -300;
    this.addChild(this.sprite)
  }
}
